import { render } from "./datatables.net.vue?vue&type=template&id=1bc45390"
import script from "./datatables.net.vue?vue&type=script&lang=js"
export * from "./datatables.net.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__